<template>
  <div class="wrapper-full">
    <div class="header-container border-bottom-thin">
      <div class="nav-container">
        <el-input
          ref="myInput"
          :placeholder="$t('langcfg.txtNameOrPID')"
          v-model.lazy="search"
          @click.native.prevent.stop="handleClick"
          @touchend.native.stop.prevent="handleClick"
        >
          <el-button
            @click.native.prevent.stop="clearInput"
            @touchend.native.stop.prevent="clearInput"
            style="width: 60px; font-size: 30px; margin: 0; padding: 0"
            slot="append"
            class="df aic jcc"
            icon="el-icon-circle-close"
          ></el-button>
        </el-input>
        <el-button @click="showAddPatient" class="iconfont icon-adds" />
        <el-button @click="editPatient" class="iconfont icon-edit" :disabled="isEditDisabled" />
        <el-button @click="deletePatient" class="iconfont icon-trash" :disabled="isEditDisabled" />
        <el-button @click="showExport" class="el-icon-upload2" />
        <el-button @click="refreshPatient" class="el-icon-refresh" />
      </div>

      <div class="patient-record-cotainer" :style="`height:${dispH - 180}px`">
        <DataTable
          :dispH="dispH - 180 - 70"
          @pulling-down="pullingDown"
          @pulling-up="pullingUp"
          @current-row-changed="selectPatient"
          :currentIndex="currentIndex"
          :headers="patientHeaders"
          :tableData="patients"
          :needSelectFirstRow="true"
        />
        <div
          class="patient-record-cotainer"
          v-if="isPageInationVisible"
          style="
            height: 60px;
            width: 100%;
            border-top: 1px solid gray;
            display: flex;
            justify-content: center;
          "
        >
          <el-pagination
            @current-change="currentPageChanged"
            :background="true"
            :page-size="pageSize"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="allPatientsCount"
            :pager-count="5"
          >
          </el-pagination>
          <input
            type="text"
            class="jupmer"
            :value="currentPage"
            @click.prevent.stop="handleClickPage"
            @touchend.stop.prevent="handleClickPage"
          />
        </div>
      </div>
    </div>
    <div v-if="isEdittingVisible" class="patient-edit">
      <PatientEdit
        :language="language"
        :patient="currentPatient"
        :addOrEdit="addOrEdit"
        @save="savePatient"
        @cancel="hidePatientEdit"
      />
    </div>
    <div class="patient-sort" v-if="!isEdittingVisible">
      <el-button @click="showSort">
        <span class="iconfont icon-icon- btn-oprator sort"></span>
      </el-button>
    </div>
  </div>
</template>
<script>
import DataTable from "./basic/DataTable";
import { Message, Size } from "../../mixins";
import PatientEdit from "./PatientEdit";
import { isDefined, isNumberString, isStringEmpty } from "../../shared/utils";
import EVENTS from "../../bus";
const { ipcRenderer } = window.require("electron");
let timoutInput;
export default {
  name: "PatientList",
  data() {
    return {
      search: "",
      addOrEdit: "add",
      patient: {},
      currentPage: 1,
      pageSize: 14
    };
  },
  mixins: [Message, Size],
  props: {
    value: {
      type: Number,
      default: 1
    },
    language: {
      type: String,
      default: ""
    },
    patients: {
      type: Array,
      default: () => {
        return [];
      }
    },
    allPatientsCount: {
      type: Number,
      default: 0
    },
    currentPatient: {
      type: Object
    },
    isEdittingVisible: {
      type: Boolean,
      default: false
    },
    patientHeaders: {
      type: Array
    }
  },
  components: {
    DataTable,
    PatientEdit
  },
  mounted() {
    this.pageSize = window.copyScreen ? 12 : 14;
  },
  methods: {
    showExport() {
      this.$emit("show-export");
    },
    refreshPatient() {
      this.$emit("search-patients");
    },
    currentPageChanged(page) {
      this.$emit("input", page);
      this.$emit("patient-page-changed", page);
    },
    clearInput() {
      this.search = "";
    },
    handleClick() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.search, (inputData) => {
        this.search = inputData;
      });
      // this.$refs.input.focus();
      this.$refs.myInput.$refs.input.focus();
    },
    handleClickPage() {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.currentPage, (inputData) => {
        if (isNumberString(inputData)) {
          let curpage = parseInt(inputData);
          if (curpage > this.max) {
            self.currentPage = this.max;
          } else if (curpage < 1) {
            self.currentPage = 1;
          } else {
            self.currentPage = curpage;
          }
          this.$emit("input", self.currentPage);
          self.$emit("patient-page-changed", parseInt(self.currentPage));
        }
      });
      // this.$refs.input.focus();
      this.$refs.myInput.$refs.input.focus();
    },
    showSort() {
      this.$emit("show-sort");
    },
    showAddPatient() {
      this.addOrEdit = "add";
      this.$emit("show-edit-patient");
    },
    deletePatient() {
      this.$emit("delete-patient");
    },
    savePatient(pat) {
      let ev = this.addOrEdit === "add" ? "add-patient" : "update-patient";
      this.$emit(ev, pat);
    },
    hidePatientEdit() {
      this.$emit("show-edit-patient");
    },
    editPatient() {
      this.addOrEdit = "edit";
      this.$emit("show-edit-patient");
    },
    selectPatient(patient) {
      this.$emit("select-patient", patient);
    },
    pullingDown(callback) {
      this.$emit("load-pre-patients", callback);
    },
    pullingUp(callback) {
      this.$emit("load-next-patients", callback);
    },
    back2top() {
      this.$emit("back-top");
    },
    getWindowMsg() {
      ipcRenderer.on("sendMsgAddFromMain2", (e, msg) => {});
    }
  },
  computed: {
    max() {
      return Math.ceil(this.allPatientsCount / this.pageSize);
    },
    isPageInationVisible() {
      return this.allPatientsCount > this.pageSize;
    },
    tableWith() {
      return this.dispW;
    },
    tableHeight() {
      return this.dispH - this.headerHeight;
    },
    isEditDisabled() {
      return !isDefined(this.currentPatient);
    },
    currentIndex() {
      if (isDefined(this.currentPatient)) {
        for (let id = 0; id < this.patients.length; id++) {
          if (this.currentPatient._id === this.patients[id]._id) {
            return id;
          }
        }
      }
      return 0;
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.currentPage = val;
      },
      immediate: true
    },
    search: function (v) {
      let condition = isStringEmpty(v)
        ? {}
        : {
            $or: [
              {
                firstname: v
              },
              {
                pid: v
              },
              {
                lastname: v
              }
            ]
          };
      clearTimeout(timoutInput);
      timoutInput = setTimeout(() => {
        this.$emit("change-page", 1);
        this.$emit("search-patients", condition);
        this.currentPage = 1;
      }, 800);
    }
  }
};
</script>
<style lang="less" scoped>
.nav-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  & > *:not(:first-child) {
    margin-left: 30px;
  }
  & > .el-button {
    font-size: 40px;
    color: white;
  }
}

/deep/ .el-input-group__append {
  padding: 0;
}

.oprators {
  height: 100%;
  padding-left: @content-to-left;
  padding-bottom: 2px;
  .btn-oprator {
    font-size: @btn-icon-fs;
    color: white;
  }
}
.btn-oprator:hover {
  color: @btn-hover-color;
}
.search-icon {
  color: black;
  font-size: 30px;
}
.patient-cotainer {
  position: relative;
  .btn-oprator {
    font-size: 38px;
    color: white;
  }
  .patient-edit {
    position: absolute;
    width: 100%;
    height: 100%;
    background: @page-background;
    top: 0px;
  }
}
.patient-record-cotainer {
  margin-top: 10px;
}
.patient-sort {
  position: absolute;
  bottom: 30px;
  left: 20px;
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  .sort {
    font-size: @btn-icon-fs+20;
  }
}

.el-pagination {
  display: flex;
  justify-content: center;
}
.el-pagination /deep/ li {
  width: 80px;
  height: 70px;
  font-size: 30px;
  line-height: 70px;
}

.el-pagination /deep/ .el-pager li {
  background-color: @page-background;
  color: white !important;
  border: 1px solid gray;
}
.el-pagination /deep/ button {
  width: 80px;
  height: 70px;
  i::before {
    font-size: 40px;
  }
}
.el-pagination /deep/ .btn-next,
.el-pagination /deep/ .btn-prev {
  background-color: @page-background;
  color: white !important;
  border: 1px solid gray;
}
.el-pagination /deep/ .el-pagination__jump {
  color: white;
  font-size: 4px;
}
.jupmer {
  color: black !important;
  height: 69px;
  line-height: 69px;
  border: 1px solid gray;
  font-size: 30px;
  width: 80px;
  text-align: center;
}
.oprators /deep/ .el-input__inner {
  font-size: 33px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/PatientList.vue